import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { prefixHTTPS } from '@hellodarwin/core/lib/features/helpers/prefix-https';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useMediaQuery } from 'react-responsive';
import { useTheme } from 'styled-components';
import { usePremiumAccess } from '../../../providers/premium-access-provider';
import { NavigationMenuItemWrapperAnchorStyled, NavigationMenuItemWrapperLinkStyled, NavigationMenuItemWrapperStyled, } from './styles';
const NavigationMenuLabelWrapper = (props) => {
    const { isExternal, external_link, pathname, subLinks, handleLinkClick, children, handleListItemsOpening, isCurrent, isCollapsed, listItemsOpen, } = props;
    const theme = useTheme();
    const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.tablet });
    const { app, menuOpen, toggleMenu } = usePlatform();
    const { isPageAccessible } = usePremiumAccess();
    const hasSubLinks = Array.isArray(subLinks)
        ? subLinks.length > 0
        : !!subLinks;
    const showSubLinksOnDesktop = hasSubLinks && !isTablet;
    const hasExternalUrl = isExternal && !!external_link;
    const hasInternalPath = !!pathname && !isExternal;
    const fullWidthFlexStyle = { width: '100%', display: 'flex' };
    const isBlockedClientPath = app === 'client' && hasInternalPath && !isPageAccessible(pathname);
    const shouldRenderInternalLink = hasInternalPath && !props.onClick && !isBlockedClientPath;
    const handleInternalLinkClick = () => {
        if (menuOpen)
            toggleMenu();
    };
    if (showSubLinksOnDesktop) {
        return (_jsx(NavigationMenuItemWrapperStyled, { as: "button", type: "button", "aria-expanded": listItemsOpen, className: "sublinks", "$isCollapsed": isCollapsed, onClick: handleListItemsOpening, children: children }));
    }
    if (hasExternalUrl) {
        return (_jsx(NavigationMenuItemWrapperAnchorStyled, { href: prefixHTTPS(external_link, 'navigation', 'partner-app'), rel: "nofollow noopener noreferrer", target: "_blank", style: fullWidthFlexStyle, children: children }));
    }
    if (shouldRenderInternalLink) {
        return (_jsx(NavigationMenuItemWrapperLinkStyled, { to: pathname, "$isCollapsed": isCollapsed, onClick: handleInternalLinkClick, style: fullWidthFlexStyle, children: children }));
    }
    if (isCurrent || handleLinkClick) {
        return (_jsx(NavigationMenuItemWrapperStyled, { "$isCollapsed": isCollapsed, className: isCurrent ? 'current' : 'clickable', onClick: isCurrent
                ? undefined
                : (e) => {
                    e.stopPropagation();
                    handleLinkClick === null || handleLinkClick === void 0 ? void 0 : handleLinkClick(props);
                }, children: children }));
    }
    if (hasInternalPath) {
        return (_jsx(NavigationMenuItemWrapperLinkStyled, { to: pathname, style: fullWidthFlexStyle, children: children }));
    }
    return _jsx(_Fragment, { children: children });
};
export default NavigationMenuLabelWrapper;
